import { connect } from 'react-redux';
import { IProfileState } from '../../../../redux';
import Credentials from './DisplayCredentials';

const mapStateToProps = (state: IProfileState) => ({
  client: state.profile.credentials.generate.client,
});

export default connect(mapStateToProps, null)(Credentials);
